import { useNavigate, useLocation } from "react-router-dom";

function useUpdateQueryParam() {
  const navigate = useNavigate();
  const location = useLocation();

  const updateQueryParam = (key, value) => {
    const currentParams = new URLSearchParams(window.location.search); // ✅ use `window.location.search` to get the latest URL

    if (value === null || value === undefined) {
      currentParams.delete(key);
    } else {
      currentParams.set(key, value);
    }

    const newSearch = currentParams.toString();
    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;

    navigate(newUrl, { replace: true });
  };

  return updateQueryParam;
}

export default useUpdateQueryParam;
